import type {ReactNode} from 'react';

export interface MarkdownRendererProps {
  content: string;
  suffix?: ReactNode;
}

export const SUFFIX_CONTAINER_CLASS = 'markdown-suffix';

export const SUFFIX_CONTAINER_MARGIN_LEFT = '2px';

export const SUFFIX_ANCHOR_SELECTOR = 'p, li, h1, h2, h3, h4, h5, h6, blockquote, dd, td, th, figcaption';

/** The tags this renderer never writes into the chat, on top of DOMPurify's html profile. */
export const FORBIDDEN_TAGS: readonly string[] = ['script', 'style', 'iframe', 'object', 'embed', 'form'];

/** Attributes that make the browser fetch a URL with no click, other than an image's src. */
export const FETCHING_ATTRIBUTES: readonly string[] = ['srcset', 'poster', 'background', 'data', 'formaction'];

/** The only element whose src may stay, and then only when it names our own media. */
export const IMAGE_TAG_NAME = 'IMG';

/** A style value that could load something: url(), image(), image-set() or src(), or a backslash, since a CSS escape can spell any of them. */
export const FETCHING_STYLE_PATTERN = /(?:url|image|image-set|src)\s*\(|\\/i;

/** Classes the site-wide lazy loaders copy an element's data-* URL into its src for. */
export const LAZY_LOAD_CLASSES: readonly string[] = ['pmw-lazy', 'js-picture-pmw-lazy', 'js-pmw-lazy', 'lazy', 'js-themes-lazy-img', 'js-lazyloaded-decoration'];
